import { useRegionReportController } from './useRegionReportController';
import { LoadingView } from './views/LoadingView';
import { DeleteConfirmationView } from './views/DeleteConfirmationView';
import { CloseConfirmationView } from './views/CloseConfirmationView';
import { NoHarvestDataView } from './views/NoHarvestDataView';
import { ReportContentView } from './views/ReportContentView';
import { DialogBaseProps } from '../../../../containers/Modal/Modal/Modal';

export const RegionReport = ({
  index
}: DialogBaseProps) => {
  const {
    activity,
    showCloseConfirmationModal,
    cropCode,
    showDeleteConfirmationModal,
    fieldBoundary,
    fieldName,
    geoJson,
    hasRegionReportData,
    isAirSeeder,
    isDetailView,
    isListView,
    isLoadingReport,
    isRegionValid,
    itemData,
    locale,
    onCancelClick,
    onCancelConfirm,
    onCancelGoBack,
    onDeleteCancelConfirm,
    onDeleteCancelGoBack,
    onDeleteConfirm,
    onClickItem,
    onNotePadClick,
    onRegionButtonClick,
    onStep2Click,
    reportData,
    saveClick,
    showSaveButton,
  } = useRegionReportController({ index });

  const dialogTestId = 'region-report-form';
  const onOpenChange = onCancelClick;
  const onCancelWithConfirmation = showSaveButton ? onOpenChange : onCancelConfirm;

  if (showCloseConfirmationModal) {
    return (
      <CloseConfirmationView
        dialogTestId={dialogTestId}
        index={index}
        onCancelConfirm={onCancelConfirm}
        onCancelGoBack={onCancelGoBack}
        onOpenChange={onCancelConfirm}
      />
    );
  }

  if (isLoadingReport) {
    return (
      <LoadingView
        dialogTestId={dialogTestId}
        onOpenChange={onCancelWithConfirmation}
        onCancelClick={onCancelWithConfirmation}
      />
    );
  }

  if (showDeleteConfirmationModal) {
    return (
      <DeleteConfirmationView
        onDeleteCancelConfirm={onDeleteCancelConfirm}
        onDeleteCancelGoBack={onDeleteCancelGoBack}
        dialogTestId={dialogTestId}
        onOpenChange={onOpenChange}
      />
    );
  }


  if (!hasRegionReportData || reportData === null) {
    return (
      <NoHarvestDataView
        activity={activity}
        fieldName={fieldName}
        geoJson={geoJson}
        isRegionValid={isRegionValid}
        locale={locale}
        onCancelConfirm={onCancelConfirm}
        onDeleteConfirm={onDeleteConfirm}
        onRegionButtonClick={onRegionButtonClick}
        saveClick={saveClick}
        showSaveButton={showSaveButton}
        dialogTestId={dialogTestId}
        onOpenChange={onOpenChange}
      />
    );
  }

  return (
    <ReportContentView
      dialogTestId={dialogTestId}
      onOpenChange={onCancelWithConfirmation}
      activity={activity}
      cropCode={cropCode}
      fieldBoundary={fieldBoundary}
      fieldName={fieldName}
      index={index}
      isAirSeeder={isAirSeeder}
      isDetailView={isDetailView}
      isListView={isListView}
      itemData={itemData}
      locale={locale}
      onDeleteConfirm={onDeleteConfirm}
      onClickItem={onClickItem}
      onNotePadClick={onNotePadClick}
      onStep2Click={onStep2Click}
      reportData={reportData}
      saveClick={saveClick}
      showSaveButton={showSaveButton}
      onCancelClick={onCancelWithConfirmation}
      onRegionButtonClick={onRegionButtonClick}
    />
  );
};
